




















import { Component, Vue } from 'vue-property-decorator';
import Topic from '@/components/Topic/index.vue'; // @ is an alias to /src
import topicList from '@/assets/data';

@Component({
  components: {
    Topic
  }
})
export default class Home extends Vue {
  // state
  isPass = false;
  isSubmitBtnPressing = false;
  topicList = topicList;
  answerList: number[] = new Array(topicList.length);
  errorList: { [id: string]: boolean }[] = new Array(topicList.length).fill({});

  // method
  topicHandler(index: number) {
    return (answerId: number) => {
      this.$set(this.answerList, index, answerId);
    };
  }
  submitAndCheck() {
    let isPass = true;
    // 检查是否填写完整
    for (let i = 0; i < this.answerList.length; i++) {
      if (this.answerList[i] === undefined) {
        alert(`第${i + 1}题还未填写`);
        return;
      }
    }
    // 检查是否正确
    for (let i = 0; i < this.answerList.length; i++) {
      const isError = this.answerList[i] !== topicList[i].answer;
      if (isError) {
        isPass = false;
      }
      if (!isError) this.isPass = true;
      this.$set(this.errorList, i, {
        [this.answerList[i]]: isError
      });
    }
    this.isPass = isPass;
  }
  submitBtnPressUp() {
    this.isSubmitBtnPressing = false;
  }

  protected mounted() {
    document.addEventListener('mouseup', this.submitBtnPressUp);
  }
  protected destroy() {
    document.removeEventListener('mouseup', this.submitBtnPressUp);
  }
}
